<template>
    <v-card class="ma-2 pa-1">
        <v-card-title>Uncompleted Tasks</v-card-title>
        <div v-if="notCompleted.length > 0">
            <Task v-for="task in notCompleted" :key="task.id" :task="task"/>
        </div>
        <v-card-text v-else>There are no unfinished tasks.</v-card-text>
    </v-card>
</template>

<script>
    import Task from "../Task";
    import { mapGetters } from 'vuex'
    export default {
        name: "UnCompleted",
        components: {
            Task
        },
        computed: {
            ...mapGetters(['notCompleted'])
        }
    }
</script>

<style scoped>

</style>